import React, { useState } from "react";
import { useParams } from "react-router-dom";
import RunningRankings from "./runningRankings";
import RankingsResults from "./rankingsResults";
import NavigationMenu from "../../components/navigationMenu";

function RankingsBuilder() {
  // let history = useHistory();
  let { rankingId } = useParams();
  const [step, setStep] = useState(1);
  const [rankedPlayers, setRankedPlayers] = useState([]);
  document.title = "Rankings Builder - FCHockey";

  return (
    <>
      <NavigationMenu />
      {step === 1 && !rankingId ? (
        <RunningRankings
          setStep={setStep}
          rankedPlayers={rankedPlayers}
          setRankedPlayers={setRankedPlayers}
        />
      ) : (
        <RankingsResults rankedPlayers={rankedPlayers} />
      )}
    </>
  );
}

export default RankingsBuilder;
